import React from 'react';
import Image from '@fhs/shared/src/components/Image/Image';
import buildClassNames from 'classnames';
import {
    withSitecoreContext,
    getFieldValue,
    Text,
    Link,
} from '@sitecore-jss/sitecore-jss-react';
import Tier from '../../components-common/Tier';
import Callout from '../../components-common/Callout';
import DesaturateImage from '../../components-common/DesaturateImage/DesaturateImage';
import './HomeArticleBlock.scss';

const HomeArticleBlock = (props) => {
    const { fields } = props;
    const articles = fields.items;
    const changeData = (data) => ({
        ...data,
        title: data.title,
        bodyContent: data.Body,
    });

    const onMouseEnterArticle = (event) => {
        event.currentTarget.classList.add('is-active');
    };

    const onMouseLeaveArticle = (event) => {
        event.currentTarget.classList.remove('is-active');
    };

    const desaturatedFlag = getFieldValue(fields, 'isDesaturated');
    const isDesaturated =
        desaturatedFlag === undefined ||
        (typeof desaturatedFlag === 'boolean' && desaturatedFlag);

    return (
        <Tier classNames="home-article-block">
            <div className="grid grid--gutter-2x">
                {getFieldValue(fields, 'leftTitle') && (
                    <div className="grid__col grid__col--4of12@lg">
                        <Text
                            tag="h2"
                            className="hdg hdg--3 hdg--weight-regular hdg--fancy-line"
                            field={fields.leftTitle}
                        />
                    </div>
                )}
                <div className="grid__col grid__col--8of12@lg">
                    <ul className="vr-array vr-array--24x">
                        {articles?.map((item) => {
                            const hasLink =
                                getFieldValue(item.fields, 'callToAction') &&
                                item.fields.callToAction.value.href;
                            const image = getFieldValue(item.fields, 'image');

                            return (
                                <li
                                    key={item.id}
                                    onMouseEnter={onMouseEnterArticle}
                                    onMouseLeave={onMouseLeaveArticle}>
                                    {image && (
                                        <>
                                            {hasLink && (
                                                <Link
                                                    className="image-link"
                                                    field={
                                                        item.fields.callToAction
                                                    }>
                                                    <div
                                                        className={buildClassNames(
                                                            {
                                                                'aspect-ratio aspect-ratio--3x2': isDesaturated,
                                                            }
                                                        )}>
                                                        {isDesaturated ? (
                                                            <DesaturateImage
                                                                image={image}
                                                                imageOnly
                                                            />
                                                        ) : (
                                                            <Image
                                                                src={image?.src}
                                                                alt={image?.alt}
                                                                classNames={{
                                                                    picture:
                                                                        'h-full',
                                                                }}
                                                                sizes={[
                                                                    {
                                                                        w: 400,
                                                                        media:
                                                                            '(max-width: 460px)',
                                                                    },
                                                                    {
                                                                        w: 720,
                                                                        media:
                                                                            '(min-width: 461px) and (max-width: 820px)',
                                                                    },
                                                                    {
                                                                        media:
                                                                            '(min-width: 821px)',
                                                                    },
                                                                ]}
                                                            />
                                                        )}
                                                    </div>
                                                </Link>
                                            )}
                                            {!hasLink && (
                                                <div
                                                    className={buildClassNames({
                                                        'aspect-ratio aspect-ratio--3x2': isDesaturated,
                                                    })}>
                                                    {isDesaturated ? (
                                                        <DesaturateImage
                                                            image={image}
                                                            imageOnly
                                                        />
                                                    ) : (
                                                        <Image
                                                            src={image?.src}
                                                            alt={image?.alt}
                                                            classNames={{
                                                                picture:
                                                                    'h-full',
                                                            }}
                                                            sizes={[
                                                                {
                                                                    w: 400,
                                                                    media:
                                                                        '(max-width: 460px)',
                                                                },
                                                                {
                                                                    w: 720,
                                                                    media:
                                                                        '(min-width: 461px) and (max-width: 820px)',
                                                                },
                                                                {
                                                                    media:
                                                                        '(min-width: 821px)',
                                                                },
                                                            ]}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                        </>
                                    )}
                                    <div className="vr vr--6x" />
                                    {/* Refactor so that .articles + .callout are not co-dependent styles */}
                                    <div className="articles">
                                        <Callout
                                            fields={changeData(item.fields)}
                                            hdgClassNames="hdg--3"
                                            isCtaButton
                                        />
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </Tier>
    );
};

export default withSitecoreContext()(HomeArticleBlock);
